import * as React from "react";

export default function FilterWrapper(props) {
  const {label, children, kind, attribute} = props;
  const classNames = ['filter-wrapper', `filter-wrapper--${kind}`];
  return (
    <details className={classNames.join(' ')} data-attribute={attribute} data-kind={kind} open={true}>
      <summary>
        <strong>{label}</strong>
        <div className="filter-wrapper__arrow"></div>
      </summary>
      <div className='filter-wrapper__content'>
        {children}
      </div>
    </details>
  );
}
